/**
 * Markdown 渲染器配置（切换渲染器只需要改这个文件）
 *
 * - rendererUrl 留空：使用本地默认渲染器 ./defaultRenderer.jsx（语雀 md → React）
 * - rendererUrl 填线上脚本地址：运行时加载脚本，用它注册的渲染器（脚本契约见 ./loader.js）
 * - rendererId：线上脚本注册到 window.__MARKDOWN_RENDERERS__ 里的 key
 *
 * 页面只依赖 <MarkdownRenderer markdown={...} />，换实现不用动页面。
 * 地址只允许 https / 同源 / localhost，且必须是可信来源（会执行第三方 JS）。
 * 线上脚本的注册方式、自带样式 / 复用项目样式两种写法见 ./README.md。
 */
export default {
  rendererUrl: "",
  rendererId: "default",
};
